// eslint-disable-next-line import/prefer-default-export
export const chunk = (array, size) => {
  const tmp = [];

  for (let index = 0; index < array.length; index += size) {
    tmp.push(array.slice(index, index + size));
  }

  return tmp;
};

export const flatten = arr => arr.reduce((result, item) => result.concat(item), []);

export const totalArraysLength = (...arrays) =>
  arrays.reduce((totalLength, array) => totalLength + (Array.isArray(array) ? array.length : 0), 0);

export const uniq = arr => arr.filter((value, index, self) => self.indexOf(value) === index);

export const uniqBy = (arr, key) => {
  const cb = o => o[key];

  return [
    ...arr
      .reduce((map, item) => {
        const key = item === null || item === undefined ? item : cb(item);

        map.has(key) || map.set(key, item);

        return map;
      }, new Map())
      .values(),
  ];
};

export const range = (start, end) => {
  const length = end - start + 1;
  return Array.from({ length }, (_, i) => start + i);
};

export const keyBy = (arr, iteratee) => {
  const baseIteratee = typeof iteratee === 'function' ? iteratee : item => item[iteratee];

  return arr.reduce((hash, item) => {
    hash[baseIteratee(item)] = item;
    return hash;
  }, {});
};

export const union = (arr1, arr2) => Array.from(new Set([...arr1, ...arr2]));

export const last = arr => arr[arr.length - 1];
